import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useAudios } from "../../../assets/useAudios"
import phonerings from '../../../assets/audio/phonerings.mp3'

import Puhelinsoi from '../../../images/animations/Puhelinsoi.gif'
import DialButton from "../../../Components/DialButton"

import './RingRingScreen.css'

const RingRingScreen = ({ nextPage, backToSelectRole }) => {
    const [goBack, setGoBack] = useState(false)
    const role = useSelector(state => state.role)
    const audio = useAudios()

    const ringing = new Audio(phonerings)
            audio.preload = 'auto'
            audio.autoplay = false

    useEffect(() => {
        if (role === 'seller') {
            playSellerAudio()
        } else {
            ringing.play()
            //audio.setAndPlay('phonerings')
        }
        // eslint-disable-next-line
    }, [])

    const endCall = () => {
        setGoBack(true)
        backToSelectRole()
    }

    const playSellerAudio = async () => {
        await audio.setAndPlay('phonedial')
        if (goBack) {
            return
        }

        await audio.setAndPlay('puhelinhalyttaa')

        if (goBack) {
            return
        }
        
        nextPage()
    }

    if (role === 'seller') {
        return (
            <div className='calling-container'>
                <div className='calling-upper'>
                    <div className='calling-header'>Soitetaan:</div>
                    <div className='calling-number'>+81 1881131</div>
                    <img className='calling-button-phone' src={Puhelinsoi} alt='puhelin soi' />
                </div>

                <div className='calling-close-button' onClick={() => endCall()}>
                    <DialButton type='decline'/>
                </div>
            </div>
        )
    }

    return (
        <div className='calling-container'>
            <div className='calling-upper'>
                <div className='calling-number-seller'>Yksityinen numero</div>
                <img className='calling-button-phone' src={Puhelinsoi} alt='puhelin soi' />
            </div>

            <div className='calling-lower'>
                <div className='calling-close-button' 
                    onClick={() => {
                        ringing.pause()
                        nextPage()
                        }}>
                        <DialButton type='answer'/>
                </div>
                <div className='calling-close-button' 
                    onClick={() => {
                        ringing.pause()
                        endCall()
                    }}>
                        <DialButton type='decline'/>
                </div>
            </div>
        </div>
    )
}

export default RingRingScreen